import React, { FC, ReactNode, AnchorHTMLAttributes } from 'react';
import classNames from 'classnames';

import { noop } from 'buyside/util/lodashAlt';

import styles from './linkStyles.scss';

/*
  type: Can be either 'normal' or 'plain'. Plain links only turn blue when hovered
        over and otherwise retain their original styling.
*/

export enum LINK_TYPES {
  NORMAL = 'normal',
  PLAIN = 'plain',
  NONE = 'none'
}

const Link: FC<{
  analyticsTag?: string;
  children?: ReactNode;
  className?: string;
  inherit?: boolean;
  onClick?: () => void;
  to?: string | null;
  type?: LINK_TYPES;
} & Partial<AnchorHTMLAttributes<HTMLAnchorElement>>> = ({
  analyticsTag,
  children,
  className,
  inherit,
  onClick = noop,
  to,
  type = LINK_TYPES.NORMAL,
  ...props
}) => {
  const linkStyle = classNames(
    styles.link,
    {
      [styles.plain]: type === LINK_TYPES.PLAIN,
      [styles.inherit]: inherit
    },
    className
  );

  const handleClick = (): void => {
    if (onClick) onClick();
  };

  if (!to) return <span className={linkStyle}>{children}</span>;

  return (
    <a href={to} className={linkStyle} onClick={handleClick} data-heap={analyticsTag} {...props}>
      {children}
    </a>
  );
};

export default Link;
